import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import React, { useEffect } from "react"
import {
  useCheckRoutingInfoQueryCache,
  useUpdateRoutingInfo
} from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { AmabAfabMedicalPreference } from "#/components/carrot-plans/steps/medical-questions/medicalFlowConstants"
import { useCalibratedEngagementEnabled } from "#/hooks/calibratedEngagement/useCalibratedEngagement"

export default function ShowMedicalPreferenceDecisionStep(): JSX.Element {
  const calibratedEngagementEnabledQuery = useCalibratedEngagementEnabled()
  const routingInfo = useCheckRoutingInfoQueryCache()
  const { send } = useStateMachine()
  const { mutateAsync } = useUpdateRoutingInfo()

  const sendValue =
    routingInfo.amabAfabMedicalPreference === AmabAfabMedicalPreference.AUTO_SKIPPED ||
    calibratedEngagementEnabledQuery.data
      ? "NO"
      : "YES"

  useEffect(() => {
    if (calibratedEngagementEnabledQuery.isLoading) return
    if (calibratedEngagementEnabledQuery.data && routingInfo.amabAfabMedicalPreference === null) {
      mutateAsync({ amabAfabMedicalPreference: AmabAfabMedicalPreference.AUTO_SKIPPED }).then(() => send(sendValue))
    } else {
      send(sendValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [calibratedEngagementEnabledQuery.isLoading])
  return <></>
}
